var app = angular.module('directives.search', []);
require('./services.scss');
require('./directive.js');
require('./service.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/search/index.js
 ** module id = 218
 ** module chunks = 1
 **/